export const INVOICES_PATH = "/fulfill/sales/invoices";

const buildInvoiceRoute = (invoiceId: string): string => `${INVOICES_PATH}/${encodeURIComponent(invoiceId)}`;

export default buildInvoiceRoute;
